module.exports = __webpack_public_path__ + "static/media/logo.12e46460.png";